<template>
  <section id="faq" class="section section-alt">
    <Container>
      <div class="faq-layout">
        <div class="faq-intro" data-reveal>
          <p class="eyebrow">Got Questions?</p>
          <h2 class="section-title">Frequently Asked Questions</h2>
          <p class="section-subtitle" style="margin-top: 1rem">
            Can't find what you're looking for? Reach out and our team will
            get back to you.
          </p>
          <a href="#footer" class="btn btn-dark faq-cta">Contact Us</a>
        </div>
        <div class="faq-list">
          <Question
            v-for="(item, index) in faqItems"
            :key="index"
            :question="item.question"
            :answer="item.answer"
          />
        </div>
      </div>
    </Container>
  </section>
</template>

<script setup>
import Container from "@/components/Container/Container.vue";
import Question from "./Question.vue"

const faqItems = [
  {
    question: "Can pregnant women take our products?",
    answer:
      "Yes, pregnant women can take our turkey berry powder and tea, as turkey berry is known for its nutritional benefits. However, we always recommend consulting with a healthcare provider before adding any new supplements or herbal products to ensure they align with individual health needs and circumstances during pregnancy. Your health and safety are our top priorities.",
  },
  {
    question:
      "How can incorporating turkey berry powder into my diet benefit my overall health?",
    answer:
      "Incorporating turkey berry powder into your diet can offer numerous health benefits. It is rich in essential vitamins and minerals, including vitamins A and C, calcium, and iron. These nutrients can help boost your immune system, support healthy skin, and improve bone health. Additionally, turkey berry is known for its antioxidant properties, which can help combat oxidative stress in the body. Regular consumption may also aid in digestion and promote overall wellness, making it a great addition to smoothies, soups, or teas.",
  },
];
</script>

<style scoped>
.faq-layout {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 4rem;
}

.faq-intro .section-title {
  text-align: left;
}

.faq-cta {
  margin-top: 2rem;
}

@media (max-width: 1023px) {
  .faq-layout {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    text-align: center;
  }

  .faq-intro .section-title {
    text-align: center;
  }
}
</style>
